
    import * as _0 from "../../../node_modules/@angular/common/fesm2022/common.mjs"
import * as _1 from "../../../node_modules/@angular/compiler/fesm2022/compiler.mjs"
import * as _2 from "../../../node_modules/@angular/core/fesm2022/core.mjs"
import * as _3 from "../../../node_modules/@angular/platform-browser/fesm2022/platform-browser.mjs"
import * as _4 from "../../../node_modules/@angular/platform-browser-dynamic/fesm2022/platform-browser-dynamic.mjs"
import * as _5 from "../../../node_modules/@webcomponents/webcomponentsjs/webcomponents-bundle.js"
import * as _6 from "../../../node_modules/angular/index.js"
import * as _7 from "../../../node_modules/aurelia-framework/dist/native-modules/aurelia-framework.js"
import * as _8 from "../../samples/sample-cross-fx/node_modules/aurelia-templating-binding/dist/native-modules/aurelia-templating-binding.js"
import * as _9 from "../../samples/sample-cross-fx/node_modules/aurelia-templating-resources/dist/native-modules/aurelia-templating-resources.js"
import * as _10 from "../../../node_modules/aurelia-pal-browser/dist/es2015/aurelia-pal-browser.js"
import * as _11 from "../../../node_modules/aurelia-event-aggregator/dist/native-modules/aurelia-event-aggregator.js"
import * as _12 from "../../../node_modules/aurelia-history-browser/dist/native-modules/aurelia-history-browser.js"
import * as _13 from "../../../node_modules/hyperapp/src/index.js"
import * as _14 from "../../../node_modules/inferno/index.esm.js"
import * as _15 from "../../../node_modules/inferno-create-element/dist/index.esm.js"
import * as _16 from "../../samples/sample-cross-fx/node_modules/mithril/index.js"
import * as _17 from "../../../node_modules/lit-element/lit-element.js"
import * as _18 from "../../../node_modules/solid-js/dist/dev.js"
import * as _19 from "../../../node_modules/solid-js/web/dist/dev.js"
import * as _20 from "../../converters/piral-ng/common.js"
import * as _21 from "../../../node_modules/preact/dist/preact.module.js"
import * as _22 from "../../../node_modules/riot/riot.esm.js"
import * as _23 from "../../../node_modules/rxjs/dist/esm5/index.js"
import * as _24 from "../../../node_modules/vue/dist/vue.runtime.esm.js"
import * as _25 from "../../../node_modules/zone.js/fesm2015/zone.js"
import * as _26 from "../../../node_modules/tslib/tslib.es6.mjs"
import * as _27 from "../../../node_modules/react/index.js"
import * as _28 from "../../../node_modules/react-dom/index.js"
import * as _29 from "../../../node_modules/react-router/esm/react-router.js"
import * as _30 from "../../../node_modules/react-router-dom/esm/react-router-dom.js"
import { DefaultErrorInfo } from 'piral-core/lib/defaults/DefaultErrorInfo.js';
import { DefaultLoadingIndicator } from 'piral-core/lib/defaults/DefaultLoadingIndicator.js';
import { DefaultLayout } from 'piral-core/lib/defaults/DefaultLayout.js';
import { DefaultRouter } from 'piral-core/lib/defaults/DefaultRouter_v5.js';
import { DefaultRouteSwitch } from 'piral-core/lib/defaults/DefaultRouteSwitch_v5.js';
import { createRedirect, createNavigation, useCurrentNavigation } from 'piral-core/lib/defaults/navigator_v5.js'
import { useGlobalStateContext } from 'piral-core/lib/hooks/globalState.js';
    
        export function applyStyle(element) {
          element.style.display = 'contents';
        }
      

    export function fillDependencies(deps) {
      deps['sample-cross-fx']={};deps["@angular/common"]=_0;deps["@angular/common@16.2.12"]=_0;deps["@angular/compiler"]=_1;deps["@angular/compiler@16.2.12"]=_1;deps["@angular/core"]=_2;deps["@angular/core@16.2.12"]=_2;deps["@angular/platform-browser"]=_3;deps["@angular/platform-browser@16.2.12"]=_3;deps["@angular/platform-browser-dynamic"]=_4;deps["@angular/platform-browser-dynamic@16.2.12"]=_4;deps["@webcomponents/webcomponentsjs"]=_5;deps["@webcomponents/webcomponentsjs@2.6.0"]=_5;deps["angular"]=_6;deps["angular@1.8.3"]=_6;deps["aurelia-framework"]=_7;deps["aurelia-framework@1.4.1"]=_7;deps["aurelia-templating-binding"]=_8;deps["aurelia-templating-binding@1.6.0"]=_8;deps["aurelia-templating-resources"]=_9;deps["aurelia-templating-resources@1.15.1"]=_9;deps["aurelia-pal-browser"]=_10;deps["aurelia-pal-browser@1.8.1"]=_10;deps["aurelia-event-aggregator"]=_11;deps["aurelia-event-aggregator@1.0.3"]=_11;deps["aurelia-history-browser"]=_12;deps["aurelia-history-browser@1.4.0"]=_12;deps["hyperapp"]=_13;deps["hyperapp@1.2.10"]=_13;deps["inferno"]=_14;deps["inferno@7.4.11"]=_14;deps["inferno-create-element"]=_15;deps["inferno-create-element@7.4.11"]=_15;deps["mithril"]=_16;deps["mithril@2.3.8"]=_16;deps["lit-element"]=_17;deps["lit-element@2.5.1"]=_17;deps["solid-js"]=_18;deps["solid-js@1.9.10"]=_18;deps["solid-js/web"]=_19;deps["piral-ng/common"]=_20;deps["piral-ng/common@1.10.2"]=_20;deps["piral-ng@1.10.2"]=_20;deps["preact"]=_21;deps["preact@10.27.3"]=_21;deps["riot"]=_22;deps["riot@4.14.0"]=_22;deps["rxjs"]=_23;deps["rxjs@7.8.2"]=_23;deps["vue"]=_24;deps["vue@2.7.16"]=_24;deps["zone.js"]=_25;deps["zone.js@0.13.3"]=_25;deps["tslib"]=_26;deps["tslib@2.8.1"]=_26;deps["react"]=_27;deps["react@18.3.1"]=_27;deps["react-dom"]=_28;deps["react-dom@18.3.1"]=_28;deps["react-router"]=_29;deps["react-router@5.3.4"]=_29;deps["react-router-dom"]=_30;deps["react-router-dom@5.3.4"]=_30
    }
  

    export { createRedirect, createNavigation };
  

    export const publicPath = "/";
  

    export function createDefaultState() {
      return {
        app: {
          error: undefined,
          loading: typeof window !== 'undefined',
          wrap: true,
        },
        components: {
          ErrorInfo: DefaultErrorInfo,
          LoadingIndicator: DefaultLoadingIndicator,
          Router: DefaultRouter,
          RouteSwitch: DefaultRouteSwitch,
          Layout: DefaultLayout,
        },
        errorComponents: {},
        registry: {
          extensions: {},
          pages: {},
          wrappers: {},
        },
        routes: {},
        data: {},
        portals: {},
        modules: [],
      };
    }
  
export function integrateDebugger() {}
export function integrateEmulator() {}

    export function useRouteFilter(paths) {
      
    useCurrentNavigation();
  
return paths;
    }
  
  